import ActionEditor from "./ActionEditor";
import { hexToRgba } from "../mustDoActionUtils";
import { Draggable } from "react-beautiful-dnd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faChevronDown,
  faChevronUp,
  faGripLines,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
import "./mustDoActionTaskItem.css";
import { InputLengthValidations, SelectedMustDoActionTask, SingleMustDoDataPointState } from "../types";
interface MustDoActionTaskItemProps {
  task: SelectedMustDoActionTask;
  index: number;
  expandedTaskId: string | null;
  handleToggleSelect: (taskId: string) => void;
  handleToggleExpand: (taskId: string) => void;
  handleMustDoEditorChange: (
    id: string,
    newValues: Array<SingleMustDoDataPointState>
  ) => void;
  selectedMustDoAction: Record<string, SingleMustDoDataPointState[]>;
  inputLengthValidations : InputLengthValidations
}
const MustDoActionTaskItem: React.FC<MustDoActionTaskItemProps> = ({
  task,
  index,
  expandedTaskId,
  handleToggleSelect,
  handleToggleExpand,
  handleMustDoEditorChange,
  selectedMustDoAction,
  inputLengthValidations
}) => {
  const { id: taskId, color, selected, infoLabel, actionId } = task;
  const isExpanded = expandedTaskId === taskId;
  const style = {
    taskNumberColor: selected ? color : "#7C7C7C",
    taskInfoContainer: {
      background: selected
        ? `linear-gradient(to right, ${hexToRgba(color, 0.125)} 0%, ${hexToRgba(
            color,
            0.05
          )} 40%, white 100%)`
        : "#F8F8F8",
      border: selected ? `1px solid ${color}` : "1px solid #F8F8F8",
      headingColor: selected ? "#606060" : "#9A9A9A",
    },
    taskToggleSelectEyeOpacity: selected ? 0.8 : 0.5,
    cursor: selected ? "pointer" : "not-allowed",
    pointerEvents: selected ? "auto" : "none",
    borderRadius: isExpanded ? "8px 8px 0 0" : "8px",
  };

  return (
    <Draggable key={taskId} draggableId={taskId} index={index}>
      {(provided) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className="configuration-item"
          style={provided.draggableProps.style}
        >
          <div className="task-number" style={{ color: style.taskNumberColor }}>
            Task {index + 1} :
          </div>
          <div
            className="task-info-container"
            style={{
              border: style.taskInfoContainer.border,
              cursor: style.cursor,
            }}
          >
            <div
              style={{
                background: style.taskInfoContainer.background,
                borderRadius: style.borderRadius,
              }}
              onClick={selected ? () => handleToggleExpand(taskId) : undefined}
              className="task-info-header"
            >
              <div>
                <div className="task-gripper">
                  <FontAwesomeIcon icon={faGripLines} />
                </div>
                <div
                  className="task-info-heading"
                  style={{ color: style.taskInfoContainer.headingColor }}
                >
                  {infoLabel.label}
                </div>
              </div>
              <FontAwesomeIcon
                icon={isExpanded ? faChevronUp : faChevronDown}
                className="task-info-expand-icon"
              />
            </div>
            {isExpanded && (
              <ActionEditor
                key={taskId}
                actionId={actionId}
                description={infoLabel.description ?? ""}
                datapoints={selectedMustDoAction?.[actionId] ?? []}
                onChange={handleMustDoEditorChange}
                inputLengthValidations = {inputLengthValidations}
              />
            )}
          </div>
          <div className="task-select-icon">
            <FontAwesomeIcon
              icon={selected ? faEye : faEyeSlash}
              style={{ opacity: style.taskToggleSelectEyeOpacity }}
              onClick={() => handleToggleSelect(taskId)}
            />
          </div>
        </div>
      )}
    </Draggable>
  );
};
export default MustDoActionTaskItem;